<template>
  <article class>
    <Overlay @on-click="$emit('close-modal')" />
    <div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
      <slot></slot>
    </div>
  </article>
</template>
<script>
import Overlay from './Overlay.vue';

export default {
  name: 'Modal',
  components: { Overlay },
};
</script>
